import { reduceToArrayMap, reduceToSetMap, reduceToMap } from '$lib/utils/array';
import { erStatic } from '../static-all';
import { immediateDerived } from '$lib/store';
import type ERAR from '$lib/erar/spec';

export const idToCharacter = immediateDerived(
  erStatic,
  (values) => {
    return reduceToMap(
      values?.result.characters ?? [],
      (v) => v.id,
      (v) => v,
    );
  },
  new Map<number, ERAR.Schema.StaticCharacterList[number]>(),
);

export const characterIdToStartWeapon = immediateDerived(
  erStatic,
  (values) => {
    return reduceToArrayMap(
      values?.result.characterWeapons ?? [],
      (v) => v.characterId,
      (v) => v,
    );
  },
  new Map<number, ERAR.Schema.StaticCharacterWeaponList>(),
);

export const characterIdToStartWeaponCategory = immediateDerived(
  erStatic,
  (values) => {
    return reduceToSetMap(
      values?.result.characterWeapons ?? [],
      (v) => v.characterId,
      (v) => v.itemSubcategoryId,
    );
  },
  new Map<number, Set<string>>(),
);

export const weaponIdToStaticBalance = immediateDerived(
  erStatic,
  (values) => {
    return reduceToArrayMap(
      values?.result.balances ?? [],
      (v) => v.characterWeaponId,
      (v) => v,
    );
  },
  new Map<number, ERAR.Schema.StaticBalanceList>(),
);

export const freeCharacters = immediateDerived(
  erStatic,
  (values) => values?.result.freeCharacters ?? [],
  [],
);
